<template>
  <div class="faq-list">
    <van-grid :column-num="store.screenState === 'landscape'?4:2" square>
      <van-grid-item v-for="item in menuList" :key="item.name">
        <van-button :style="{backgroundColor: item.bgColor}" :to="{path: '/faq/detail', query: {id: item.faqType}}">
          <template>
            <div class="box-icon">
              <div>
                <van-image class="icon-img" :src="item.path" fit="contain"></van-image>
              </div>
              <span class="icon-txt">{{store.langConfig[item.name]}}</span>
            </div>
          </template>
        </van-button>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
export default {
  name: 'FaqList',
  props: {
    store: Object
  },
  data(){
    return {
      menuList: [
      {
        name: 'characteristicPlayMethod',
        faqType: 1,
        path: require('../../assets/icon-play.png'),
        bgColor: '#999'
      }, {
        name: 'storeValueCorrelation',
        faqType: 7,
        path: require('../../assets/icon-userpay.png'),
        bgColor: '#999'
      }, {
        name: 'accountCorrelation',
        faqType: 2,
        path: require('../../assets/icon-userphone.png'),
        bgColor: '#599d00'
      }, {
        name: 'functionIntroduction',
        faqType: 4,
        path: require('../../assets/icon-features-desc.png'),
        bgColor: '#999'
      }, {
        name: 'report',
        faqType: 3,
        path: require('../../assets/icon-report.png'),
        bgColor: '#999'
      }, {
        name: 'personalData',
        faqType: 5,
        path: require('../../assets/icon-personal-data.png'),
        bgColor: '#999'
      }, {
        name: 'emailPreferences',
        faqType: 6,
        path: require('../../assets/icon-email.png'),
        bgColor: '#999'
      }]
    }
  },
}
</script>

<style lang="scss" scoped>
.faq-list {
  .van-button {
    width: 160px;
    height: 160px;
    border-radius: 20px;
  }
  ::v-deep {
    .van-hairline--top::after {
      border: none;
    }
    .van-grid-item__content::after {
      border: none
    }
  }
  .icon-img {
    margin-bottom: 10px;
    height: 55px;
  }
  .icon-txt {
    font-size: 18px;
    color: #fff;
  }
}

@media screen and (orientation: landscape) {
  .faq-list {
    ::v-deep {
      .van-grid-item__content {
        padding: 12px;
      }
    }
    
    .van-button {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      padding: 0;
    }
    .box-icon {
      .icon-img {
        margin-bottom: 10px;
        height: 30px;
      }
      .icon-txt {
        font-size: 12px;
        color: #fff;
      }
    }
    
  }
}
</style>